import React from "react";
import { Table } from "react-bulma-components";
import {formatCurrency, addVat, readableDate, formatDate} from "../../utils";
import logo from "../Nav/img/Logo.jpg";
import { Columns } from "react-bulma-components";

class PrintQuote extends React.Component {
  PartRow(part, estimate) {
    return (
      <tr key={`p${part.id}`}>
        <td></td>
        <td></td>
        <td></td>
        <td>{part.name}</td>
        <td>{estimate ? formatCurrency(part.estimated_customer_cost) : formatCurrency(part.customer_cost)}</td>
      </tr>
    );
  }

  WorkRow(work, estimate) {
    let rows = [];
    rows.push(
      <tr key={work.id} className="table-print-highlight">
        <td>{work.description}</td>
        <td>{work.estimated_labour_hours}</td>
        <td>{estimate ? formatCurrency(work.estimated_customer_labour_cost) : formatCurrency(work.customer_labour_cost)}</td>
        <td></td>
        <td></td>
      </tr>
    );
    rows = rows.concat(work.parts.map(part => this.PartRow(part, estimate)));
    return rows;
  }

  render() {
    const job = this.props.data;
    const isEstimate = this.props.estimate
    const estimated_work_items = job.estimated_work_items.filter(
      item => !item.added_after_quote
    );


    let labourTotal = 0;
    let partsTotal = 0;

    for (let i = 0; i < estimated_work_items.length; i++) {
      if (estimated_work_items[i].chargeable === this.props.chargeable) {
        if(isEstimate){
          labourTotal += 1 * estimated_work_items[i].estimated_customer_labour_cost;
        }
        else{
          labourTotal += 1 * estimated_work_items[i].customer_labour_cost;
        }
        for (let j = 0; j < estimated_work_items[i].parts.length; j++) {
          if(isEstimate){
            partsTotal += 1 * estimated_work_items[i].parts[j].estimated_customer_cost;
          }
          else{
            partsTotal += 1 * estimated_work_items[i].parts[j].customer_cost
          }
        }
      }
    }

    return (
      <div className="page">
        <div>
          <Columns>
            <h1 className="job-card-print-title" data-testid={"title"}>
              Quote - {job.vehicle.registration} - {job.id} - {readableDate(formatDate(new Date()))} - {job.department.name}
            </h1>
          </Columns>
          <Table bordered size={"fullwidth"}>
            <thead>
              <tr className="header-row">
                <td>Registration</td>
                <td>Make</td>
                <td>Model</td>
                <td>Customer</td>
                {job.duplicate && <td>Off Hire Date</td>}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td data-testid={"vehicle-reg"}>{job.vehicle.registration}</td>
                <td data-testid={"vehicle-make"}>{job.vehicle.make ? job.vehicle.make.name : ""}</td>
                <td data-testid={"vehicle-model"}>{job.vehicle.model ? job.vehicle.model.name : ""}</td>
                <td data-testid={"customer"}>
                  {this.props.chargeable
                    ? job.customer2
                      ? job.customer2.display_name
                      : ""
                    : job.customer
                    ? job.customer.display_name
                    : ""}
                </td>
                {job.duplicate && <td data-testid={"quote-off-hire-date"}>{readableDate(job.off_hire_date)}</td>}
              </tr>
            </tbody>
          </Table>
          <Table bordered size={"fullwidth"}>
            <thead>
              <tr className="header-row">
                <td>Description</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td data-testid={"job-description"}>{job.description}</td>
              </tr>
            </tbody>
          </Table>
          <Table bordered size={"fullwidth"}>
            <thead>
              <tr className="header-row">
                <td>Total Labour Cost</td>
                <td>Total Parts Cost</td>
                <td>Total Cost</td>
                <td>Total Cost (Inc VAT)</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td data-testid={"total-labour-cost"}>{formatCurrency(labourTotal)}</td>
                <td data-testid={"total-parts-cost"}>{formatCurrency(partsTotal)}</td>
                <td data-testid={"total-cost"}>{formatCurrency(labourTotal + partsTotal)}</td>
                <td data-testid={"total-cost-vat"}>{formatCurrency(addVat(labourTotal + partsTotal))}</td>
              </tr>
            </tbody>
          </Table>
        </div>
        <div>
          {
            <Table bordered size={"fullwidth"}>
              <thead>
                <tr className="header-row">
                  <td>Work Description</td>
                  <td>Labour Hours</td>
                  <td>Labour Cost</td>
                  <td>Part Name</td>
                  <td>Part Cost</td>
                </tr>
              </thead>
              <tbody>
                {Object.entries(estimated_work_items).length > 0 &&
                  Object.entries(estimated_work_items)
                    .filter(
                      item => item[1].chargeable === this.props.chargeable
                    )
                    .sort((a, b) => a[0].description < b[0].description)
                    .map(entry => this.WorkRow(entry[1], this.props.estimate))}
              </tbody>
            </Table>
          }
        </div>
        <p className="terms">All prices are excluding VAT. Our standard terms and conditions apply. A copy of
          these can be found on our website.</p>
      </div>
    );
  }
}

export default PrintQuote;
